export default {
  bind(el, binding, vnode) {
    el.checkFullscreenAvailability = () => {
      const isInIframe = window !== window.top;

      if (isInIframe) {
        try {
          // Try to access parent to check if we have permission
          // This will throw an error if we don't have permission due to same-origin policy
          window.parent.document;

          // If we're in an iframe and can access parent, check if fullscreen is allowed
          return (
            document.fullscreenEnabled &&
            (window.frameElement?.allowFullscreen ||
              window.frameElement?.getAttribute('allowfullscreen') !== null)
          );
        } catch (e) {
          // If we can't access parent, assume fullscreen is not available
          return false;
        }
      } else {
        // If we're not in an iframe, check if browser supports fullscreen
        return document.fullscreenEnabled;
      }
    };

    const isFullscreenAvailable = el.checkFullscreenAvailability();

    if (!isFullscreenAvailable) {
      el.style.display = 'none';
    }
  },

  unbind(el) {
    el.checkFullscreenAvailability = null;
  },
};
